import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { locationService } from '@/shared/services/location.service';
import type { Country, State } from '@/shared/types';
import { locationQueryKeys } from './queryKeys';

export const useCountries = (): UseQueryResult<Country[], Error> => {
  return useQuery({
    queryKey: locationQueryKeys.countries,
    queryFn: locationService.getCountries,
    staleTime: 30 * 60 * 1000, // 30 minutes - countries rarely change
  });
};

export const useStates = (
  countryCode: string
): UseQueryResult<State[], Error> => {
  return useQuery({
    queryKey: locationQueryKeys.states(countryCode),
    queryFn: () => locationService.getStatesByCountryCode(countryCode),
    enabled: !!countryCode,
    staleTime: 30 * 60 * 1000,
  });
};
